import { Target } from "@labs/shared/types/Target.ts";

export const calculateBusinessGrowth = (target: Partial<Target>): number => {
  if (typeof target.expectedBusinessGrowth !== "number") return 0;

  const yearsUntilTarget =
    Number(target.targetYear) - Number(target.baselineYear);
  return (
    Math.pow(1 + target.expectedBusinessGrowth / 100, yearsUntilTarget) - 1
  );
};
